export default "__VITE_ASSET__BSpgxS2g__"